'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactIconBase = require('react-icon-base');

var _reactIconBase2 = _interopRequireDefault(_reactIconBase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var TiChartArea = function TiChartArea(props) {
    return _react2.default.createElement(
        _reactIconBase2.default,
        _extends({ viewBox: '0 0 40 40' }, props),
        _react2.default.createElement(
            'g',
            null,
            _react2.default.createElement('path', { d: 'm33.3 10c0-1-0.4-1.9-1.2-2.6-1.5-1.2-3.6-0.9-4.7 0.5l-4.7 5.8-4-3c-1.5-1.1-3.5-0.9-4.6 0.6l-6.7 8.3c-0.5 0.6-0.7 1.3-0.7 2.1v5h26.6v-16.7z m0 21.7h-26.6c-1 0-1.7 0.7-1.7 1.6s0.7 1.7 1.7 1.7h26.6c1 0 1.7-0.7 1.7-1.7s-0.7-1.6-1.7-1.6z' })
        )
    );
};

exports.default = TiChartArea;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/react-icons/lib/ti/chart-area.js
// module id = 3025
// module chunks = 0